<template>
  <div class="spot-the-not">
    <link v-for="(value, index) in images[0].canvases" :key="index" rel="preload" as="image" :href="require(`../assets/spot-the-not/${value.image}@2x.png`)">
    <link rel="preload" as="image" :href="require(`@/assets/spot-the-not/${images[0].image}.jpg`)" :imagesrcset="require(`@/assets/spot-the-not/${images[0].image}.jpg`) + ' 1x, ' + require(`../assets/spot-the-not/${images[0].image}@2x.jpg`) + ' 2x'">
    <ImageCount :current="clickedImages" :total="totalImages" />
    <div class="spot-the-not-image">
      <img :src="require(`@/assets/spot-the-not/${images[0].image}.jpg`)" :srcset="require(`@/assets/spot-the-not/${images[0].image}.jpg`) + ' 1x, ' + require(`../assets/spot-the-not/${images[0].image}@2x.jpg`) + ' 2x'" alt="">
      <Canvas v-for="(value, index) in images[0].canvases" :key="index" :image="require(`../assets/spot-the-not/${value.image}@2x.png`)" :imageLeft="`${value.left - 47.5}px`" :imageTop="`${value.top - 47.5}px`" :id="`canvas-${index}`" :top="`${value.top - 47.5}px`" :left="`${value.left - 47.5}px`" :width="`${value.width + 95}px`" :height="`${value.height + 95}px`" @click.native="showOverlay"></Canvas>
    </div>
    <Correct v-if="clickedImages == totalImages" />
  </div>
</template>

<script>
import ImageCount from '@/components/ImageCount.vue'
import Canvas from '@/components/Canvas.vue'
import SpotTheNotService from '@/services/SpotTheNotService'
import Correct from '@/components/Correct.vue'

export default {
  components: {
    ImageCount,
    Canvas,
    Correct
  },
  data() {
    return {
      images: [],
      totalImages: 0,
      clickedImages: 0
    }
  },
  methods: {
    shuffle(array) {
      let currentIndex = array.length;
      let temporaryValue, randomIndex;

      while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array
    },
    showOverlay(e) {
      const container = document.querySelector('.spot-the-not-image')
      const overlay = e.target.dataset.image
      const imageLeft = e.target.dataset.imageLeft
      const imageTop = e.target.dataset.imageTop
      const imageWidth = e.target.dataset.imageWidth
      const imageHeight = e.target.dataset.imageHeight

      e.target.style.pointerEvents = "none"

      const elem = document.createElement('img')
      elem.src = overlay
      elem.style.position = 'absolute'
      elem.classList.add('overlay')
      elem.style.top = imageTop
      elem.style.left = imageLeft
      elem.style.width = imageWidth
      elem.style.height = imageHeight

      container.appendChild(elem)

      this.clickedImages += 1

      if(this.clickedImages == this.totalImages) {
        setTimeout(() => {
          this.clickNext()
        }, 500);
      }
    },
    clickNext() {
      this.images.shift()

      if(this.images.length < 1) {
        this.$router.push('/final')
      }

      let overlays = document.querySelectorAll('.overlay')
      let canvases = document.querySelectorAll('canvas')

      overlays.forEach(element => {
        element.parentNode.removeChild(element)
      })

      canvases.forEach(element => {
        element.style.pointerEvents = "all"
      })
    
      this.totalImages = this.images[0].canvases.length
      this.clickedImages = 0

      this.buttonText = ""
      this.color = ""
    },
    preloadImage(url){
      let img=new Image()
      img.src=url
    }
  },
  mounted() {
    SpotTheNotService.getImages().then((resp) => {
      this.images = resp.data

      this.$nextTick(() => {
        this.shuffle(this.images)
        this.totalImages = this.images[0].canvases.length
        this.images.map((image) => {
          this.preloadImage(`../assets/spot-the-not/${image.image}.jpg`)
          this.preloadImage(`../assets/spot-the-not/${image.image}@2x.jpg`)

          image.canvases.map((canvas) => {
            this.preloadImage(`../assets/spot-the-not/${canvas.image}.png`)
            this.preloadImage(`../assets/spot-the-not/${canvas.image}@2x.png`)
          })
        })
      });
    })
  }
}
</script>

<style lang="scss">
.spot-the-not {
  height: 100%;
}
.spot-the-not-image {
  height: 375px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  // overflow: hidden;

  img {
    height: 375px;
    width: auto;
  }

  .overlay {
    background: none;
    z-index: 20;
  }
}
</style>